/** @format */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'product-reviews-chips',
    templateUrl: './review-chips.component.html',
    styleUrls: ['./review-chips.component.scss'],
    standalone: false
})
export class ReviewChipsComponent {
	@Input() label = '';
	@Input() displayCancelSign = false;
	@Input() isSelected = false;
	@Input() displayChip = true;
	@Output() chipClicked: EventEmitter<unknown> = new EventEmitter();

	actionClicked() {
		this.chipClicked.emit(null);
	}
}
